import InvestorFlow from '../components/InvestorFlow.svelte';

new InvestorFlow({
  target: document.getElementById('dealmaker-investor-flow-embed'),
  props: {
    apiUrl: script.getAttribute('data-api-url') || '',
    dealId: script.getAttribute('data-deal-id') || '',
    invitationUid: script.getAttribute('data-invitation-id') || '',
    hosted: !(script.getAttribute('data-hosted') === 'false'),
    displayLogo: script.getAttribute('data-display-logo') === 'true',
    inTemplatePage: script.getAttribute('data-in-template-page') === 'true',
  },
});
